var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrashIconRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0825 8.6251L13.6933 18.7501M8.30675 18.7501L7.9175 8.6251M19.1315 5.01385C19.5163 5.07235 19.8987 5.13422 20.2812 5.2006M19.1315 5.01385L17.93 20.6322C17.881 21.2681 17.5937 21.862 17.1256 22.2953C16.6576 22.7285 16.0433 22.969 15.4055 22.9689H6.5945C5.95673 22.969 5.3424 22.7285 4.87435 22.2953C4.4063 21.862 4.11904 21.2681 4.07 20.6322L2.8685 5.01385M19.1315 5.01385C17.8331 4.81756 16.528 4.66858 15.2188 4.56722M2.8685 5.01385C2.48375 5.07122 2.10125 5.1331 1.71875 5.19947M2.8685 5.01385C4.1669 4.81756 5.47201 4.66858 6.78125 4.56722M15.2188 4.56722V3.53672C15.2188 2.20922 14.195 1.10222 12.8675 1.0606C11.6228 1.02082 10.3772 1.02082 9.1325 1.0606C7.805 1.10222 6.78125 2.21035 6.78125 3.53672V4.56722M15.2188 4.56722C12.4104 4.35019 9.58956 4.35019 6.78125 4.56722",
    stroke: "#FF0000",
    strokeWidth: 1.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashIconRed);
export default __webpack_public_path__ + "static/media/trashIconRed.b805ba1a203f3cd3c29b3f2ac67af010.svg";
export { ForwardRef as ReactComponent };